module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"overview":"Overview","products":"Products","active products":"Active products","open invoices":"Open invoices","open invoices amount":"Open invoices amount"},"de":{"overview":"Übersicht","products":"Produkte","active products":"Aktive Produkte","open invoices":"Offene Rechnungen","open invoices amount":"Offener Rechnungsbetrag"}}')
  delete Component.options._Ctor
}
